import { useEffect, useState } from "react";
import fleetApi from "@/lib/fleetApi";
import { loadTripCodes, tripFlags } from "@/lib/tripCodes";
import { needsWheelchair } from "@/components/portal/AutoAssignDialog";

const ITEMS = [["aba", "ABA"], ["wheelchair", "Wheelchair"], ["alone", "Ride alone"], ["seat", "Escort / monitor"], ["plain", "Standard NEMT"]];

// After an import, count how the trip codes sorted the new trips.
export function ImportCodeSummary({ tripIds, days }) {
  const [counts, setCounts] = useState(null);

  useEffect(() => {
    const ids = new Set(tripIds || []);
    if (!ids.size || !days.length) return;
    Promise.all([loadTripCodes(), ...days.map((d) => fleetApi.get(`/trips?date=${d}&limit=5000`).then((r) => r.data || []).catch(() => []))])
      .then(([, ...lists]) => {
        const c = { aba: 0, wheelchair: 0, alone: 0, seat: 0, plain: 0 };
        lists.flat().filter((t) => ids.has(t.id)).forEach((t) => {
          const f = tripFlags(t);
          const wc = f.wheelchair || needsWheelchair(t);
          if (f.aba) c.aba += 1;
          if (wc) c.wheelchair += 1;
          if (f.alone) c.alone += 1;
          if (f.escort || f.monitor) c.seat += 1;
          if (!f.aba && !wc && !f.alone && !f.escort && !f.monitor) c.plain += 1;
        });
        setCounts(c);
      });
  }, [tripIds, days]);

  if (!counts) return null;
  return (
    <div className="mt-3 flex flex-wrap items-center gap-2 text-xs" data-testid="import-code-summary">
      <span className="text-emerald-300/80">Found:</span>
      {ITEMS.map(([k, label]) => (
        <span key={k} className={`rounded-full border px-2.5 py-0.5 font-mono-data ${counts[k] ? "border-emerald-500/40 bg-emerald-500/10 text-emerald-200" : "border-slate-700 text-slate-500"}`} data-testid={`import-code-count-${k}`}>
          {counts[k]} {label}
        </span>
      ))}
    </div>
  );
}
